import { SelectFields } from '@repo/toolkit/types'

import { HowDidYouObtainLecBrochure } from '../../models/how-did-you-obtain-lec-brochures/how-did-you-obtain-lec-brochure'
import { FieldsSelector } from '../../utils'

export const howDidYouObtainLECBrochureFields = [
  'id',
  'name'
] as const satisfies FieldsSelector<HowDidYouObtainLecBrochure>

export type HowDidYouObtainLECBrochureType = SelectFields<
  HowDidYouObtainLecBrochure,
  typeof howDidYouObtainLECBrochureFields
>
